// AdminOne ONLY — Connector Status Page.
import React, { useCallback, useEffect, useState } from "react";
import { SHELL, connectorsApi } from "@/api/connectorPackClient";
import ConnectorStatusCard from "@/components/connectors/ConnectorStatusCard";
import MissingCredentialChecklist from "@/components/connectors/MissingCredentialChecklist";

export default function AdminOneConnectorStatusPage() {
  const [data, setData]   = useState(null);
  const [err, setErr]     = useState("");
  const [busy, setBusy]   = useState({});
  const load = useCallback(async () => {
    setErr("");
    try { setData(await connectorsApi.status()); }
    catch (e) { setErr(String(e.message || e)); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onVerify  = useCallback(async (name) => {
    setBusy((b) => ({ ...b, [name]: "verify" }));
    try { await connectorsApi.verify(name); await load(); } catch (e) { setErr(String(e.message || e)); }
    finally { setBusy((b) => ({ ...b, [name]: null })); }
  }, [load]);
  const onDisable = useCallback(async (name) => {
    setBusy((b) => ({ ...b, [name]: "disable" }));
    try { await connectorsApi.disable(name); await load(); } catch (e) { setErr(String(e.message || e)); }
    finally { setBusy((b) => ({ ...b, [name]: null })); }
  }, [load]);

  const connectors = data?.connectors || [];
  return (
    <div style={SHELL.page} data-testid="adminone-connectors-page">
      <h2 style={SHELL.h2}>AdminOne · Hardening v1 · Connector Governance</h2>
      <h1 style={SHELL.h1}>Connector Status</h1>
      <p style={SHELL.dim}>
        Presence-only. Raw credentials are never returned. Live status requires real keys.
      </p>
      {err && <div style={SHELL.err} data-testid="connectors-err">{err}</div>}
      <div style={SHELL.panel}>
        <h2 style={SHELL.h2}>Registry · {connectors.length} connectors · {data?.live_count ?? 0} live · {data?.missing_count ?? 0} missing keys</h2>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(360px, 1fr))", gap: 16, marginTop: 18 }}>
        {connectors.map((c) => (
          <ConnectorStatusCard
            key={c.name}
            connector={c}
            busy={busy[c.name]}
            onVerify={() => onVerify(c.name)}
            onDisable={() => onDisable(c.name)}
          />
        ))}
      </div>
      <MissingCredentialChecklist connectors={connectors} />
    </div>
  );
}
